import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function(){
    return (
        <div className="loadSpinnerDef">
            <Spinner animation="border" variant="primary" role="status" /> <span style={{ marginLeft: '30px' }}>Loading...</span>
        </div>
    );
}